module.exports = __webpack_public_path__ + "img/update-pensions-charities-gyms.f605f705.png";